import axios from 'axios';
import { camelizeKeys } from 'humps';
import mcache from 'memory-cache';

const DEFAULT_CACHING_TIME = 5 * 60 * 1000;
const instance = axios.create({
  timeout: Number(process.env.APP_AXIOS_TIMEOUT),
});

export const request = async (params, camelize = true, cache = true) => {
  let response;

  if (cache && (!params?.method || params.method === 'get')) {
    const key = JSON.stringify(params);
    const responseFromCache = mcache.get(key);

    if (!responseFromCache) {
      response = await instance(params);
      mcache.put(key, response, cache.time ?? DEFAULT_CACHING_TIME);
    } else {
      response = responseFromCache;
    }
  }

  if (!response) {
    response = await instance(params);
  }

  return camelize ? camelizeKeys(response.data) : response.data;
};

export default request;
